import { render, staticRenderFns } from "./SiapaKamiMobile.vue?vue&type=template&id=ab1619a4&scoped=true"
import script from "./SiapaKamiMobile.vue?vue&type=script&lang=js"
export * from "./SiapaKamiMobile.vue?vue&type=script&lang=js"
import style0 from "./SiapaKamiMobile.vue?vue&type=style&index=0&id=ab1619a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1619a4",
  null
  
)

export default component.exports